



















import Icon from '../../../shared/components/Icon.vue';
import { iconClassEnum } from '../../../shared/enums/iconClassEnum';
import { defineComponent, ref } from 'vue';
import GlobalSearchBar from './GlobalSearchBar.vue';

export default defineComponent({
  name: 'GlobalSearchToggle',
  components: { GlobalSearchBar, Icon },
  props: {
    searchedQuery: { type: String, default: '' },
  },
  emits: ['search'],
  setup() {
    const isToggled = ref<boolean>(false);
    return { isToggled, iconClassEnum };
  },
});
